/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordresetrequirederror3Inputs */

const en_passwordresetrequirederror3 = /** @type {(inputs: Passwordresetrequirederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please reset your password.`)
};

const de_passwordresetrequirederror3 = /** @type {(inputs: Passwordresetrequirederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte setz dein Passwort zurück.`)
};

/**
* | output |
* | --- |
* | "Please reset your password." |
*
* @param {Passwordresetrequirederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordresetrequirederror3 = /** @type {((inputs?: Passwordresetrequirederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordresetrequirederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordresetrequirederror3(inputs)
	return de_passwordresetrequirederror3(inputs)
});
export { passwordresetrequirederror3 as "passwordResetRequiredError" }